'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const outlinedStar = 'M16 24.64l8.74 6.1c.6.42 1.4-.17 1.2-.88l-3.1-10.18 8.5-6.45c.6-.45.3-1.4-.45-1.4L20.2 11.6 16.74 1.54c-.25-.7-1.24-.7-1.48 0l-3.5 10.06-10.65.22c-.73.02-1.04.96-.44 1.4l8.5 6.46-3.1 10.18c-.2.7.6 1.3 1.2.87l8.74-6.1zm-7.8 3.52l2.6-8.56c.1-.32-.02-.65-.28-.85l-7.12-5.4 8.94-.2c.33 0 .6-.2.72-.52L16 4.16l2.94 8.47c.1.3.4.52.72.53l8.94.2-7.13 5.4c-.26.18-.37.52-.27.84l2.6 8.56-7.35-5.1c-.27-.2-.63-.2-.9 0l-7.34 5.1z';
const filledStar = 'M16.63 24.9l9 6.27c.63.44 1.46-.16 1.23-.9L23.68 19.8l8.75-6.65c.6-.46.3-1.43-.47-1.45l-11-.24L17.4 1.1c-.26-.7-1.28-.7-1.53 0l-3.6 10.36-10.98.24c-.77.02-1.1 1-.48 1.45l8.76 6.64-3.2 10.48c-.2.73.6 1.33 1.24.9l9-6.28z';

exports.filledStar = filledStar;
exports.outlinedStar = outlinedStar;
